import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css'],
  imports: [
    MatProgressBarModule,
    CommonModule
  ]
})
export class ProgressBarComponent {
  @Input() progress!: number;  // Progress value
  @Input() sectionId!: string;  // Section ID (section1 or section2)
  @Input() selectedSection!: string;  // Selected section (for conditional styling)
  @Input() sectionName: string;
  @Input() viewMode: boolean = false;  // Flag to disable click handler in viewMode

  @Output() scrollToSection: EventEmitter<string> = new EventEmitter<string>();


  scrollToSectionHandler(sectionId: string) {
    if (!this.viewMode) {
      console.log('sectionId', sectionId);
      this.scrollToSection.emit(sectionId);
    }
  }
}
